import React from 'react';

import AggregatedProductAttributesView from '../AggregatedProductAttributesView';

const AggregatedPublishedDetails = () => (
  <AggregatedProductAttributesView mode="published" />
);

export default AggregatedPublishedDetails;
